import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

//widget
import ButtonComp from '../widget/w-button';

interface ToasterProps {
  actionButtonLabel?: string;
  handleAction?: () => void;
  toastText: string;
  closebtn?: boolean;
}
const Toaster: React.FC<ToasterProps> = ({
  handleAction,
  actionButtonLabel,
  toastText,
  closebtn,
}) => {
  useEffect(() => {});

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAction();
    }
  };

  return (
    <div className='row d-flex align-items-center h-6'>
      {actionButtonLabel ? (
        actionButtonLabel.length < 10 ? (
          <div className={'col-7'}> {toastText} </div>
        ) : (
          <div className={closebtn ? 'col-11' : 'col-12'}> {toastText} </div>
        )
      ) : (
        <div className={closebtn ? 'col-11' : 'col-12'}> {toastText} </div>
      )}
      {actionButtonLabel && (
        <div
          className={
            actionButtonLabel.length < 10
              ? 'col'
              : 'col-12 toaster-height'
          }
        >
          <ButtonComp
            buttonClass={
              actionButtonLabel.length < 10
                ? 'nostyle fw-medium text-end pe-3 t-p-100 float-end'
                : 'nostyle fw-medium text-end pe-3 t-p-100 float-end position-relative toaster-overflow'
            }
            ariaLabel={actionButtonLabel}
            label={actionButtonLabel}
            handleButtonClick={() => {
              handleAction();
            }}
            tabIndex={1}
          />
        </div>
      )}
    </div>
  );
};

export default Toaster;
